var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-4 text-center"},[_vm._v(" "+_vm._s(_vm.$t("hiWelcome"))),_c('br'),_vm._v(" "+_vm._s(_vm.$t("navigateSideMenu"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }